export default __webpack_public_path__ + "static/cryto-new-d41b399a0fed670a64179e06b5e30ba2.png";